import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CashStack, ClipboardCheck, Folder2Open, PeopleFill, PersonBadge, Speedometer2 } from 'react-bootstrap-icons';
import { getStoreDashboard } from '../../services/storeAuthApi';
import '../../assets/styles/storePortal.css';

const StoreDashboard = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    getStoreDashboard()
      .then((response) => {
        setData(response.data);
        setHasError(false);
      })
      .catch(() => {
        setHasError(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const localUser = JSON.parse(localStorage.getItem('storeUser') || '{}');
  const user = data?.storeUser || localUser;
  const outletName = data?.outletName || user?.outletName || 'Your Store';

  if (isLoading) {
    return (
      <div className="store-dashboard">
        <div className="store-dashboard-loading store-dashboard-hero" aria-live="polite">
          <div className="store-skeleton store-skeleton-title" />
          <div className="store-skeleton store-skeleton-line" />
          <div className="store-skeleton store-skeleton-line short" />
        </div>
        <div className="store-dashboard-grid">
          {[1, 2, 3].map((item) => (
            <div className="store-dashboard-card store-dashboard-loading-card" key={item}>
              <div className="store-skeleton store-skeleton-icon" />
              <div className="store-skeleton store-skeleton-line" />
              <div className="store-skeleton store-skeleton-line short" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  const actionCards = [
    {
      title: 'Active Employees',
      description: 'View active employees mapped to your outlet.',
      path: '/store/employees',
      icon: PeopleFill,
    },
    {
      title: 'Uniform Forms',
      description: 'Create and track uniform requests for your store.',
      path: '/store/uniform-forms',
      icon: ClipboardCheck,
    },
    {
      title: 'Store Documents',
      description: 'View files uploaded by admin for your store.',
      path: '/store/files',
      icon: Folder2Open,
    },
    ...(data?.hasSalaryStatement === true ? [{
      title: 'Salary Statement',
      description: 'View salary statements available for your outlet.',
      path: '/store/salary-statements',
      icon: CashStack,
    }] : []),
    {
      title: 'Store Profile',
      description: 'Store login and outlet details.',
      icon: PersonBadge,
      disabled: true,
    },
  ];

  return (
    <div className="store-dashboard">
      <section className="store-dashboard-hero">
        <div className="store-dashboard-hero-icon">
          <Speedometer2 />
        </div>
        <div>
          <span className="store-dashboard-eyebrow">Store dashboard</span>
          <h2>Welcome, {outletName}</h2>
          <p>
            Manage requests, documents, and store details for <strong>{outletName}</strong>.
          </p>
          {hasError && (
            <div className="store-dashboard-alert">
              We could not refresh live dashboard data, so we are showing saved store details.
            </div>
          )}
        </div>
      </section>

      <div className="store-dashboard-grid">
        {actionCards.map(({ title, description, path, icon: Icon, disabled }) => {
          const cardContent = (
            <>
              <div className="store-dashboard-card-icon">
                <Icon />
              </div>
              <div>
                <h3>{title}</h3>
                <p>{description}</p>
              </div>
              <span className="store-dashboard-card-cta">{disabled ? 'Coming soon' : 'Open'}</span>
            </>
          );

          if (disabled) {
            return (
              <div className="store-dashboard-card disabled" key={title} aria-disabled="true">
                {cardContent}
              </div>
            );
          }

          return (
            <Link className="store-dashboard-card" to={path} key={title}>
              {cardContent}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default StoreDashboard;
